module.exports = __webpack_public_path__ + "img/big_1_36.ed803981.png";